import { Component, Inject, ViewChild } from '@angular/core';
import { InputComponent } from '../../../shared/components/input/input.component';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Recebimento } from '../../../shared/models/recebimento';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RecebimentoService } from '../../../shared/services/recebimento.service';
import { ToastService } from '../../../shared/services/toast.service';
import { ToastState as ts } from '../../../shared/enums/toast-state.enum';
import { TegelModule } from '@scania/tegel-angular-17';
import { CreateRecebimentoDTO } from '../models/create-recebimento';
import { SelectComponent } from '../../../shared/components/select/select.component';
import { DropDownOption } from '../../../shared/models/drop-down-option';
import { DatePipe } from '@angular/common';
import { PhoneHelper } from '../../../shared/helpers/phone.helper';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-dialog-recebimento',
  imports: [
    InputComponent,
    ModalComponent,
    TegelModule,
    ReactiveFormsModule,
    SelectComponent,
  ],
  providers: [DatePipe],
  templateUrl: './dialog-recebimento.component.html',
  styleUrl: './dialog-recebimento.component.scss',
})
export class DialogRecebimentoComponent {
  @ViewChild(ModalComponent) modal!: ModalComponent;
  form: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<DialogRecebimentoComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      recebimento: Recebimento | null;
      localList: DropDownOption[];
    },
    private fb: FormBuilder,
    private recebimentoService: RecebimentoService,
    private toast: ToastService,
  ) {
    this.form = this.fb.group({
      id: [data?.recebimento?.id ?? 0],
      senha: [
        data?.recebimento?.senha ?? '',
        [Validators.required, Validators.maxLength(20)],
      ],
      celular: [data?.recebimento?.celular ?? '', [Validators.maxLength(19)]],
      critico: [data?.recebimento?.critico ?? false],
      milkrun: [data?.recebimento?.milkrun ?? false],
      local: [data?.recebimento?.localId ?? null, [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.form.get('celular')?.valueChanges.subscribe((value: string) => {
      const formatted = PhoneHelper.formatToBrazilianMobile(value);
      if (value !== formatted) {
        this.form.get('celular')?.setValue(formatted, { emitEvent: false });
      }
    });
  }

  onSave(formData: any) {
    const cleanedNumer = PhoneHelper.cleanForApi(formData.celular);

    const dto: CreateRecebimentoDTO = {
      id: formData.id,
      senha: formData.senha,
      dataEntrada: new Date().toISOString(),
      celular: cleanedNumer,
      critico: formData.critico,
      milkrun: formData.milkrun,
      localId: formData.local,
    };

    this.insert(dto);
  }

  private insert(data: CreateRecebimentoDTO) {
    this.recebimentoService
      .insert(data)
      .pipe(finalize(() => this.modal?.stopLoading()))
      .subscribe({
        next: (result) => {
          if (result.success) {
            this.toast.showToast(ts.success, 'Recebimento criado com sucesso!');
            this.dialogRef.close(result.content);
          } else {
            this.toast.showToast(
              ts.error,
              result.messages?.[0] || 'Erro ao criar recebimento',
            );
          }
        },
        error: (e) => {
          const msg = e.error[0] || 'Erro inesperado ao criar recebimento';
          this.toast.showToast(ts.error, msg);
        },
      });
  }
}
